module.exports = __webpack_public_path__ + "static/about-header-small.551d2960.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about-header-small.jpg
// module id = 109
// module chunks = 253626871324061 263791100135453